// this file is a list of all the delegator references for the tracking
// manager to instantiate.

import GtmProductImpressionClickDelegatorInstance from './gtmProductImpressionClickDelegator';
import GtmRemoveFromBasketDelegatorInstance from './gtmRemoveFromBasketDelegator';
import GtmRemoveAllFromBasketDelegatorInstance from './gtmRemoveAllFromBasketDelegator';
import GtmUpdateBasketDelegatorInstance from './gtmUpdateBasketDelegator';
import GtmAddToBasketDelegatorInstance from './gtmAddToBasketDelegator';
import GtmBundleAddToBasketDelegatorInstance from './gtmBundleAddToBasketDelegator';
import GtmProductDetailViewDelegatorInstance from './gtmProductDetailViewDelegator';
import GtmImpulsiveBuyDelegatorInstance from './gtmImpulsiveBuyDelegator';
import GtmPromotionClickDelegatorInstance from './gtmPromotionClickDelegator';
import GtmProductImpressionViewDelegatorInstance from './gtmProductImpressionViewDelegator';
import GtmProductImpressionViewRichRelevanceDelegatorInstance from './gtmProductImpressionViewRichRelevanceDelegator';
import GtmPromotionViewsDelegatorInstance from './gtmPromotionViewDelegator';
import GtmTransactionDelegatorInstance from './gtmTransactionDelegator';
import GtmBasketFreeGiftDelegatorInstance from './gtmBasketFreeGiftDelegator';
import GtmEventClickDelegatorInstance from './gtmEventClickDelegator';
import GtmCheckoutViewDelegatorInstance from './gtmCheckoutViewDelegator';
import GtmRegistrationViewDelegatorInstance from './gtmRegistrationViewDelegator';
import GtmReorderAddToBasketDelegatorInstance from './gtmReorderAddToBasketDelegator';

const delegatorClassList = [
	// add additional delegators to this list
	GtmProductImpressionClickDelegatorInstance,
	GtmRemoveFromBasketDelegatorInstance,
	GtmRemoveAllFromBasketDelegatorInstance,
	GtmUpdateBasketDelegatorInstance,
	GtmAddToBasketDelegatorInstance,
	GtmBundleAddToBasketDelegatorInstance,
	GtmProductImpressionViewDelegatorInstance,
	GtmProductDetailViewDelegatorInstance,
	GtmProductImpressionViewRichRelevanceDelegatorInstance,
	GtmImpulsiveBuyDelegatorInstance,
	GtmPromotionClickDelegatorInstance,
	GtmPromotionViewsDelegatorInstance,
	GtmTransactionDelegatorInstance,
	GtmBasketFreeGiftDelegatorInstance,
	GtmEventClickDelegatorInstance,
	GtmCheckoutViewDelegatorInstance,
	GtmRegistrationViewDelegatorInstance,
	GtmReorderAddToBasketDelegatorInstance,
];

export default delegatorClassList;
